import React from 'react'

const AgendaFormFilterDatesButtons = ({location, OnClickDatePickerReset, current, OnClickDatePickerThisDay, OnClickDatePickerThisWeek, OnClickDatePickerThisWeekend}) => {
	// Validation des props et gestion des erreurs
	if (location === undefined || location === null) {
		return (
			<div role="region" aria-label="Boutons de filtres de dates d'événements" className="agenda-form-filter-dates-buttons-error">
				<div role="alert" aria-live="polite">
					<p>Erreur : propriété de localisation manquante ou invalide</p>
				</div>
			</div>
		)
	}

	// Construction des aria-label pour les boutons
	const resetLabel = "Réinitialiser les filtres de dates"
	const todayLabel = current === 'day' ? "Aujourd'hui (sélectionné)" : "Sélectionner aujourd'hui"
	const weekLabel = current === 'week' ? "Cette semaine (sélectionnée)" : "Sélectionner cette semaine"
	const weekendLabel = current === 'weekend' ? "Ce week-end (sélectionné)" : "Sélectionner ce week-end"
	const containerLabel = location === 'home' ? "Boutons de filtres de dates pour la page d'accueil" : "Boutons de filtres de dates"

	// Vérification des fonctions de callback
	const hasResetFunction = typeof OnClickDatePickerReset === "function"
	const hasDayFunction = typeof OnClickDatePickerThisDay === "function"
	const hasWeekFunction = typeof OnClickDatePickerThisWeek === "function"
	const hasWeekendFunction = typeof OnClickDatePickerThisWeekend === "function"

	// Si aucune fonction n'est disponible, afficher un message d'erreur
	if (!hasResetFunction && !hasDayFunction && !hasWeekFunction && !hasWeekendFunction) {
		return (
			<div role="region" aria-label="Boutons de filtres de dates d'événements" className="agenda-form-filter-dates-buttons-error">
				<div role="alert" aria-live="polite">
					<p>Erreur : aucune fonction de gestion des dates n'est disponible</p>
				</div>
			</div>
		)
	}

	return (
		<div 
			className={`agenda-filters-dates-buttons${location === 'home' ? ' agenda-filters-home-dates-buttons' : ''}`}
			role="group" 
			aria-label={containerLabel}
			aria-describedby="agenda-form-filter-dates-buttons-description"
		>
			{/* Description accessible pour les lecteurs d'écran */}
			<div 
				id="agenda-form-filter-dates-buttons-description" 
				className="visually-hidden" 
				aria-live="polite"
			>
				Boutons pour filtrer les événements par période de dates
			</div>

			{hasResetFunction && (
				<button 
					className={`agenda-filters-dates-reset${location === 'home' ? ' agenda-filters-home-dates-reset' : ''}`} 
					onClick={OnClickDatePickerReset}
					aria-label={resetLabel}
					aria-describedby="agenda-form-filter-dates-buttons-description"
					type="button"
				>
					Toutes les dates
				</button>
			)}

			{hasDayFunction && (
				<button 
					className={`agenda-filters-dates-day${location === 'home' ? ' agenda-filters-home-dates-day' : ''}${current === 'day' ? ' active' : ''}`} 
					onClick={OnClickDatePickerThisDay}
					aria-label={todayLabel}
					aria-describedby="agenda-form-filter-dates-buttons-description"
					aria-pressed={current === 'day'}
					type="button"
				>
					Aujourd'hui
				</button>
			)}

			{hasWeekFunction && (
				<button 
					className={`agenda-filters-dates-week${location === 'home' ? ' agenda-filters-home-dates-week' : ''}${current === 'week' ? ' active' : ''}`} 
					onClick={OnClickDatePickerThisWeek}
					aria-label={weekLabel}
					aria-describedby="agenda-form-filter-dates-buttons-description"
					aria-pressed={current === 'week'}
					type="button"
				>
					Cette semaine
				</button>
			)}

			{hasWeekendFunction && (
				<button 
					className={`agenda-filters-dates-weekend${location === 'home' ? ' agenda-filters-home-dates-weekend' : ''}${current === 'weekend' ? ' active' : ''}`} 
					onClick={OnClickDatePickerThisWeekend}
					aria-label={weekendLabel}
					aria-describedby="agenda-form-filter-dates-buttons-description"
					aria-pressed={current === 'weekend'}
					type="button"
				>
					Ce week-end
				</button>
			)}

			{/* Message de statut pour les lecteurs d'écran */}
			<div 
				className="visually-hidden" 
				aria-live="polite" 
				aria-label="Statut des boutons de filtres de dates"
			>
				Boutons de filtres de dates chargés avec succès
			</div>
		</div>
	)
}

export default AgendaFormFilterDatesButtons
